<template>
  <div>
    <van-sidebar
      style="position: relative"
      v-model="activeKey"
      @change="onchenages"
    >
      <van-sidebar-item disabled title="问题类型" />
      <van-sidebar-item
        v-for="item in title"
        :key="item.id"
        :title="item.problem"
      />
    </van-sidebar>
    <div class="detail">
      <div style="font-size: 18px; font-weight: 700">常见问题解决方法</div>
      <div style="margin: 10px 0" v-for="item in problrm" :key="item.name">
        <span
          style="
            font-size: 16px;
            font-weight: 800;
            border-left: 3px solid red;
            padding: 0 5px;
          "
        >
          问题:
        </span>
        <span style="width: 80%; font-size: 16px; padding-top: 10px">
          {{ item.title }}
        </span>
        <div
          style="padding: 10px; font-size: 16px; color: rgba(128, 128, 128, 1)"
        >
          <span>解决方案:</span>
          <span>{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { problemGetList, problemGetbyCard } from "@/api/cardOperation";
  export default {
    data() {
      return {
        title: [],
        activeKey: 1,
        problrm: [],
      };
    },
    created() {},
    mounted() {
      this.titles();
    },
    methods: {
      titles() {
        problemGetbyCard().then((res) => {
          if (res.status) {
            this.title = res.data;
            this.onchenages(1);
          }
        });
      },
      onchenages(s) {
        this.problrm = [];
        problemGetList(this.title[s - 1].id).then((res) => {
          if (res.status) {
            this.problrm = res.data;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    position: absolute;
    top: 0;
    right: 2%;
    width: 75%;
    padding: 20px 10px;
    text-align: left;
    box-sizing: border-box;
  }
</style>
